module.exports = __webpack_public_path__ + "img/productions_22.4c5d7a44.png";